import { Download } from "lucide-react";
import { useTranslate } from "ra-core";
import { Button } from "@/components/ui/button";

import { detectPlatform, installState } from "./installApp";
import { isStandalone, useInstallPrompt } from "./installPrompt";

/** En tête des paramètres sur téléphone : installer l'application, ou dire où elle est. */
export const InstallAppSection = () => {
  const translate = useTranslate();
  const { promptAvailable, installed, install } = useInstallPrompt();
  const state = installState({
    standalone: isStandalone(),
    platform: detectPlatform(navigator.userAgent, navigator.maxTouchPoints),
    promptAvailable,
    installed,
  });
  if (state === "hidden") return null;
  const t = (key: string) => translate(`resources.projects.install.${key}`);
  const steps = state === "ios_steps" ? "ios" : "android";

  return (
    <section className="rounded-lg border bg-card p-4">
      <div className="flex items-center gap-3">
        <img
          src="./appIcon/192.png"
          alt=""
          className="size-11 shrink-0 rounded-xl"
        />
        <div className="min-w-0">
          <h2 className="text-base font-semibold">
            {t(state === "installed" ? "installed_title" : "title")}
          </h2>
          <p className="text-sm text-muted-foreground">
            {t(state === "installed" ? "installed" : "intro")}
          </p>
        </div>
      </div>
      {state === "prompt" && (
        <Button className="mt-4 w-full" onClick={install}>
          <Download />
          {t("button")}
        </Button>
      )}
      {(state === "ios_steps" || state === "android_steps") && (
        <>
          <ol className="mt-4 flex list-decimal flex-col gap-2 pl-5 text-sm">
            <li>{t(`${steps}_step1`)}</li>
            <li>{t(`${steps}_step2`)}</li>
            <li>{t(`${steps}_step3`)}</li>
          </ol>
          <p className="mt-3 text-xs text-muted-foreground">{t("already")}</p>
        </>
      )}
    </section>
  );
};
